<template>
  <div class="container-fluid">
    <div class="row mt-2">
      <div class="col-lg-12 bg-white border-radius-xl p-3">
        <div>
          <div class="text-center">
            <h4>Consulta de Afiliados</h4>
            <span class="text-center" style="font-weight: 400; font-size: small;">
              Ingresa los datos y realiza tu busqueda
            </span>
          </div>
          <hr class="horizontal dark" />
          <div class="row pl-2 pr-2">
            <div class="col-md-4"></div>
            <div class="col-md-2">
              <label class="form-control-label">Documento de Identidad <span class="text-danger">*</span></label>
              <input type="text" class="form-control" v-model="documentoIdentidad">
            </div>
            <div class="col-md-2">
              <button
                class="btn btn-addiuva-dark w-100"
                style="margin-top: 30px;"
                @click="searchAfiliados"
                :disabled="!documentoIdentidad"
                title="Consultar"
              >
                <i class="fas fa-search pr-1"></i> Consultar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ======================================= RESPONSE ======================================= -->
    <div class="row mt-2">
      <div class="col-lg-12 bg-white border-radius-xl p-3">
        <div class="row p-2">
          <Toast />
          <DataTable :value="afiliaciones" ref="dtAfiliaciones" stripedRows paginator :rows="10" :rowsPerPageOptions="[5, 10, 20, 50]" tableStyle="min-width: 50rem">
            <template #empty> <center class="text-gray">No hay resultados que mostrar. </center></template>
            <Column field="idAfiliado" header="ID Afiliado" sortable></Column>
            <Column field="documentoIdentidad" header="Doc. Identidad" sortable></Column>
            <Column field="nombres" header="Nombres" sortable></Column>
            <Column field="apellidos" header="Apellidos" sortable></Column>
            <Column field="tipoCobertura" header="Tipo Cobertura" sortable></Column>
            <Column field="valorCobertura" header="Valor Cobertura" sortable></Column>
            <Column field="importeMaximo" header="Importe Máximo" sortable></Column>
            <Column field="totalImporteMaximo" header="Total Importe Máximo" sortable></Column>
            <template #paginatorstart>
              <button class="btn btn-light" @click="exportCSV($event)" title="Exportar" v-if="afiliaciones.length>0">
                <i class="fas fa-download"></i> Exportar CSV
              </button>
            </template>
          </DataTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Toast from 'primevue/toast';
import axios from 'axios';
import authHeader from '../services/auth-header';
export default {
  name: "consulta-afiliados",
  components: {
    DataTable,
    Column,
    Toast,
  },
  data() {
    return {
      API_URL: process.env.VUE_APP_API_BASE_URL,
      documentoIdentidad: null,
      afiliaciones: [],
    };
  },
  methods: {
    searchAfiliados() {
      this.afiliaciones = [];
      let payload = {
        "idAfiliado": "",
        "documentoIdentidad": this.documentoIdentidad ?? '',
        "sucursal": "Addiuva Center",
        "departamento": ""
      }
      // Send Data by Axios
      let url = this.API_URL + "/consulta_afiliado";
      axios({
        url: url,
        method: 'post',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            let data = response.data.data;
            let afiliaciones = [];
            data.forEach(a => {
              afiliaciones.push({
                idAfiliado: a.idAfiliado,
                nombres: a.nombres,
                apellidos: a.apellidos,
                valorCobertura: a.valorCobertura,
                importeMaximo: a.importeMaximo,
                totalImporteMaximo: a.totalImporteMaximo,
                tipoCobertura: a.tipoCobertura,
                documentoIdentidad: a.documentoIdentidad,
              });
            });
            afiliaciones.forEach(afiliado => {
              afiliado.tarifa = (afiliado.tarifa != '') ? 'Bs. '+ afiliado.tarifa : '';
            });
            this.afiliaciones = afiliaciones;
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    capitalize(str) {
      const str2 = str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      return str2;
    },
    changeIsoToDate: function(isoDate) {
      let date = new Date(isoDate);
      let year = date.getFullYear();
      let month = date.getMonth()+1;
      let dt = date.getDate();
      if (dt < 10) {
        dt = '0' + dt;
      }
      if (month < 10) {
        month = '0' + month;
      }
      return year+'-' + month + '-'+dt;
    },
    validateRoute(){
      let menus = this.getProfileMe?.data.menu.filter( menu => {
        return (menu.path.toLowerCase().indexOf(this.$route.path.substring(1)) != -1);
      });
      if ( menus.length == 0 ) {
        //this.$router.push({name: 'Dashboard'});
      }
    },
    exportCSV() {
      this.$refs.dtAfiliaciones.exportCSV();
    }
  },
  watch: {
    getProfileMe(val) {
      if (val) {
        this.validateRoute();
      }
    }
  },
  computed: {
    getProfileMe() {
      return this.$store.getters["profile/me"];
    }
  },
  mounted() {
    // this.validateRoute();
  }
};
</script>
<style>
.p-splitbutton-defaultbutton{
  display: none !important;
}
.p-button-icon-only {
  border-radius: 50px !important;
}
</style>